export default __webpack_public_path__ + "static/media/exposure_m.3201d99c.jpg";